import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const revenueAccountsRoutes: Routes = [
  {
    path: 'revenue-accounts',
    title: 'Erlöskonten',
    loadComponent: () =>
      import('./revenue-accounts-list/revenue-accounts-list').then(
        m => m.RevenueAccountsListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'revenue-accounts/new',
    title: 'Neues Erlöskonto',
    loadComponent: () =>
      import('./revenue-account-form/revenue-account-form').then(
        m => m.RevenueAccountFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'revenue-accounts/:id/edit',
    title: 'Erlöskonto bearbeiten',
    loadComponent: () =>
      import('./revenue-account-form/revenue-account-form').then(
        m => m.RevenueAccountFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
];
